( function () {
	'use strict';

	function calendarSlidebox ( mwlCalendarSlideBoxDirective ) {
		return angular.extend( {}, mwlCalendarSlideBoxDirective[ 0 ], {
			'templateUrl' : '/templates/schedules/calendar-slidebox/calendar-slidebox.html',
			'restrict'    : 'EA',
			'replace'     : true,
			'scope'       : {
				'dateClicked'        : '=',
				'isOpen'             : '=',
				'events'             : '=',
				'onEventClick'       : '=',
				'editEventHtml'      : '=',
				'onEditEventClick'   : '=',
				'deleteEventHtml'    : '=',
				'onDeleteEventClick' : '='
			}
		} );
	}

	angular
		.module( 'app.schedules' )
		.directive( 'calendarSlidebox', calendarSlidebox );
} )( );
